(function () {
  const ONAM_PRODUCT_IDS = [11871989367052, 8406133833996];
  const ONAM_VARIANT_ID = 54882511388940;
  const NOTICE_ID = 'onam-preorder-notice';
  const STYLE_ID = 'onam-preorder-notice-styles';
  const MESSAGE =
    'Since your order contains a Onam Sadhya Kit, the entire order will be delivered between 20th and 26th August';

  const toNumber = (value) => {
    const match = String(value || '').match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  };

  const isOnamProduct = (product) => {
    if (!product) return false;

    return (
      ONAM_PRODUCT_IDS.includes(toNumber(product.product_id)) ||
      toNumber(product.id) === ONAM_VARIANT_ID ||
      toNumber(product.variant_id) === ONAM_VARIANT_ID
    );
  };

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .onam-preorder-notice {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: rgba(0, 0, 0, 0.5);
      }

      .onam-preorder-notice__dialog {
        position: relative;
        width: min(100%, 460px);
        border-radius: 12px;
        background: #ffffff;
        padding: 28px;
        box-shadow: 0 18px 50px rgba(0, 0, 0, 0.24);
        color: #111111;
      }

      .onam-preorder-notice__close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 34px;
        height: 34px;
        border: 0;
        border-radius: 50%;
        background: #eeeeee;
        color: #111111;
        cursor: pointer;
        font-size: 22px;
        line-height: 1;
      }

      .onam-preorder-notice__title {
        margin: 0 40px 12px 0;
        font-size: 22px;
        line-height: 1.25;
        font-weight: 600;
      }

      .onam-preorder-notice__message {
        margin: 0 0 22px;
        color: #444444;
        font-size: 16px;
        line-height: 1.55;
      }

      .onam-preorder-notice__button {
        min-height: 44px;
        border: 0;
        border-radius: 22px;
        background: #004e46;
        color: #ffffff;
        cursor: pointer;
        padding: 0 26px;
        font: inherit;
        font-weight: 600;
      }

      .onam-preorder-notice__button:hover,
      .onam-preorder-notice__button:focus-visible {
        background: #003f39;
        color: #ffffff;
      }
    `;
    document.head.appendChild(style);
  };

  const closeNotice = () => {
    const notice = document.getElementById(NOTICE_ID);
    if (notice) notice.remove();
    document.removeEventListener('keydown', handleKeydown);
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape') closeNotice();
  };

  const showNotice = () => {
    ensureStyles();
    closeNotice();

    const notice = document.createElement('div');
    notice.id = NOTICE_ID;
    notice.className = 'onam-preorder-notice';
    notice.innerHTML = `
      <div class="onam-preorder-notice__dialog" role="dialog" aria-modal="true" aria-labelledby="onam-preorder-notice-title">
        <button class="onam-preorder-notice__close" type="button" aria-label="Close">×</button>
        <h2 class="onam-preorder-notice__title" id="onam-preorder-notice-title">Pre-order delivery notice</h2>
        <p class="onam-preorder-notice__message">${MESSAGE}</p>
        <button class="onam-preorder-notice__button" type="button">Got it</button>
      </div>
    `;

    notice.addEventListener('click', (event) => {
      if (
        event.target === notice ||
        event.target.closest('.onam-preorder-notice__close') ||
        event.target.closest('.onam-preorder-notice__button')
      ) {
        closeNotice();
      }
    });

    document.body.appendChild(notice);
    document.addEventListener('keydown', handleKeydown);

    const actionButton = notice.querySelector('.onam-preorder-notice__button');
    if (actionButton) actionButton.focus({ preventScroll: true });
  };

  document.addEventListener('product-ajax:added', (event) => {
    if (isOnamProduct(event.detail && event.detail.product)) {
      showNotice();
    }
  });
})();
